(function () {
  // ======================================================================
  // ASSISTENZA E ACCESSIBILITA' NEL MENU
  // ----------------------------------------------------------------------
  // I pulsanti stanno nel markup di hs-megamenu-mobile-actions, nascosti
  // di partenza: qui si mostrano solo quando il widget corrispondente e'
  // caricato — una voce che non fa nulla e' peggio di una voce assente.
  // ======================================================================

  function mostra() {
    var chat = document.querySelector('[data-pq-chat]');
    var a11y = document.querySelector('[data-pq-a11y]');
    if (chat && typeof window.zE === 'function') chat.hidden = false;
    if (a11y && window.UserWay && typeof window.UserWay.widgetOpen === 'function') a11y.hidden = false;
    return (!chat || !chat.hidden) && (!a11y || !a11y.hidden);
  }

  // Il menu si chiude prima di aprire il widget: restava davanti e il
  // pannello compariva sotto, invisibile.
  function chiudiMenu() {
    var close = document.querySelector('.hs-megamenu-close');
    if (close && !close.classList.contains('hidden')) close.click();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pq-chat]')) {
      e.preventDefault();
      chiudiMenu();
      // Il ritardo lascia finire l'animazione di chiusura del menu.
      setTimeout(function () {
        // messenger e non webWidget: Zendesk ha cambiato API, e il vecchio
        // nome funziona solo sui negozi non ancora migrati.
        try { window.zE('messenger', 'open'); }
        catch (err) { try { window.zE('webWidget', 'open'); } catch (e2) {} }
      }, 320);
    }
    if (e.target.closest('[data-pq-a11y]')) {
      e.preventDefault();
      chiudiMenu();
      setTimeout(function () {
        try { window.UserWay.widgetOpen(); } catch (err) {}
      }, 320);
    }
  });

  // I widget si caricano dopo la pagina: si riprova per quindici secondi.
  var tent = 0;
  var t = setInterval(function () {
    if (mostra() || ++tent > 30) clearInterval(t);
  }, 500);
  mostra();
})();